<PublicOnly>
  <p>
    Once you've confirmed the install is successful and you're receiving query data in pganalyze, we
    recommend setting up <a href="/docs/log-insights/setup">Log Insights</a> as a follow-up step, to
    automatically track log events in your database.
  </p>
</PublicOnly>
